import { useQuery } from '@tanstack/react-query'
import { supabase } from '@/lib/supabase'

export type CronStatus = 'ok' | 'stale' | 'last_run_failed' | 'never_run'

export interface CronHealthRow {
  function_name: string
  last_success_at: string | null
  last_error_at: string | null
  last_duration_ms: number | null
  last_error_message: string | null
  status: CronStatus
}

/**
 * Read get_cron_health() RPC (deployed 2026-04-24, migration
 * 20260424000001_get_cron_health_rpc.sql).
 *
 * The RPC is SECURITY DEFINER and granted to authenticated. Admin's Supabase
 * client carries an authenticated session, so this should succeed. If it
 * returns a permission error, that's the documented fallback case in the
 * Step 1 plan: add anon to the GRANT in a one-line follow-up migration.
 *
 * Refresh: 60s refetch / 30s stale.
 * Rows arrive pre-sorted by GREATEST(last_success_at, last_error_at) DESC.
 */
export function useCronHealth() {
  return useQuery({
    queryKey: ['cron-health'],
    queryFn: async (): Promise<CronHealthRow[]> => {
      const { data, error } = await supabase.rpc('get_cron_health')
      if (error) throw error
      return (data ?? []) as CronHealthRow[]
    },
    staleTime: 30_000,
    refetchInterval: 60_000,
  })
}
